import script from "./fullscreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./fullscreen.vue?vue&type=script&setup=true&lang=ts"

import "./fullscreen.vue?vue&type=style&index=0&id=92b0eeb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92b0eeb4"]])

export default __exports__